import { Stack, TextField, Typography, Rating as StarRating } from '@mui/material';
import Rating from 'components/Rating/Rating';
import React from 'react';
import { useTranslation } from 'react-i18next';
import './AssessStep.scss';

interface AssessStepProps {
  averageNote?: string;
  rating: string | null;
  ratingComment: string | null;
  setRating: (rate: string) => void;
  setRatingComment: (comment: string) => void;
}

const AssessStep = ({ averageNote, rating, ratingComment, setRating, setRatingComment }: AssessStepProps) => {
  const { t } = useTranslation();

  const [value, setValue] = React.useState<number | null>(0);

  const starLabels: { [index: string]: string } = {
    5: '5',
    4: '4',
    3: '3',
    2: '2',
    1: '1',
    0: '0',
  };

  function getStarLabelText(value: number) {
    return `${value} Star${value !== 1 ? 's' : ''}, ${starLabels[value]}`;
  }

  return (
    <Stack alignItems="flex-start">
      <Stack width="100%">
        <Typography className="text-modal">{t('Please assess the service performance')}</Typography>
        <Stack direction="row" justifyContent="flex-start">
          <StarRating
            name="hover-feedback"
            value={value}
            precision={1}
            size="large"
            getLabelText={getStarLabelText}
            onChange={(event, newValue) => {
              setRating(newValue?.toString() ?? '');
              setValue(newValue);
            }}
            sx={{
              fontSize: '2.5rem', // Adjust this value to your liking (e.g., 4rem, 60px)
              '& .MuiRating-icon': {
                // Optional: adds a bit more spacing between larger stars
                marginRight: '5px',
              },
            }}
          />
        </Stack>

        {averageNote && (
          <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 2 }}>
            <Typography fontWeight={700} fontStyle="italic">
              {t('Reminder')}:
            </Typography>
            <Typography fontStyle="italic">{t('average assessment for this order is')}</Typography>
            <Rating size="small" rating={averageNote} />
          </Stack>
        )}
        {rating !== null && rating <= '3' && (
          <Stack sx={{ mt: 2 }}>
            <Typography fontWeight={500}>
              {t(`You entered a ${rating} assessment. Please comment on your dissatifaction below`)}:
            </Typography>
            <TextField
              name="rating_comment"
              id="rating_comment"
              rows={11}
              className="active-blue no-border deliverables-input "
              value={ratingComment}
              onChange={(e) => setRatingComment(e.currentTarget.value)}
              placeholder={t('Your text here')}
              multiline
              fullWidth
            />
            <Typography sx={{ color: '#b2bcd5' }}>{`${t('Number of characters')}: ${
              ratingComment ? ratingComment.length : 0
            }/700`}</Typography>
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};

export default AssessStep;
